import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import LoginAgentes from '../views/agentes/Login.vue'
import { Network } from "@capacitor/network"

Vue.use(VueRouter)

const getters = store.getters

const routes = [
  {
    path: '/',
    name: 'menu_principal',
    component: () => import('@/views/menu-principal.vue'),
    meta: {
      navBarGradient: 'transparent',
      hideNavBar: true
    }
  },
  {
    path: '/new-version',
    name: 'new_version',
    component: () => import('../views/new_version.vue'),
    meta: {
      navBarGradient: 'white',
      hideNavBar: true,
    }
  },
  {
    path: '/help/:slug',
    name: 'help',
    component: () => import('../views/Help.vue'),
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('../views/Menu.vue'),
    meta: {
      hideNavBar: true,
      showNavigation: true,
    }
  },
  {
    path: '/password/new',
    name: 'password',
    component: () => import('../views/password/Passwordnew.vue'),
    meta: {
      navBarGradient: 'white',
      hideNavBar: true
    }
  },
  {
    path: '/password/reset/:token',
    name: 'password_reset',
    component: () => import('../views/password/reset'),
    meta: {
      navBarGradient: 'white',
      hideNavBar: true
    }
  },
  {
    path: '/inicio',
    name: 'inicio',
    component: () => import('@/views/Index.vue'),
    meta: {
      requiresAuth: true,
      spotBanner: true,
      showNavigation: true,
    }
  },

  {
    path: '/fase-inicio',
    name: 'fase_inicio',
    component: () => import('../views/fase-inicio/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/compradores',
    name: 'fase_inicio_compradores',
    component: () => import('../views/fase-inicio/compradores.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/patrocinadores',
    name: 'fase_inicio_patrocinadores',
    component: () => import('../views/fase-inicio/patrocinadores.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/negocios',
    name: 'fase_inicio_negocios',
    component: () => import('../views/fase-inicio/negocios.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/gestores',
    name: 'fase_inicio_gestores',
    component: () => import('../views/fase-inicio/gestores.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/cupones',
    name: 'fase_inicio_cupones',
    component: () => import('../views/fase-inicio/cupones.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fase-inicio/campanias-cupones',
    name: 'fase_inicio_campanias-cupones',
    component: () => import('../views/fase-inicio/campanias-cupones.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/red-social',
    name: 'red_social',
    component: () => import('../views/red-social/index.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },

  // TUTORIAL VIDEOS
  {
    path: '/tutorial',
    name: 'tutorial',
    component: () => import('../views/tutorial/index.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // CREDITO SINERGIA
  {
    path: '/credito-sinergia',
    name: 'credito_sinergia',
    component: () => import('../views/credito-sinergia/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/credito-sinergia/:idCredito',
    name: 'credito_sinergia_detalle',
    component: () => import('../views/credito-sinergia/detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // SUSCRIPCIONES ANTES PAQUETES
  {
    path: '/suscripciones/compra',
    component: () => import('../views/suscripciones/compra.vue'),
    children: [
      {
        path: 'herramientas',
        component: () => import('../views/suscripciones/herramientas.vue'),
        name: 'herramientas-compra',
      },
      {
        path: ':paqueteId(\\d+)?',
        component: () => import('../views/suscripciones/paquetes-especiales.vue'),
        name: 'suscripciones_compra',
      },
    ],
    meta: {
      requiresAuth: true
    }
  },


  // FONDOS

  {
    path: '/fondos',
    name: 'miembros-f',
    component: () => import('../views/fondos/miembros-f.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/:slug',
    name: 'fondo_detalle',
    component: () => import('../views/fondos/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/f4/adquirir',
    name: 'fondo-f4-adquirir',
    component: () => import('../views/fondos/f4/adquirir.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/:slug/adquirir',
    name: 'fondo_adquirir',
    component: () => import('../views/fondos/adquirir'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/:slug/orden',
    name: 'fondo_orden',
    component: () => import('../views/fondos/orden'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/f4/participaciones',
    name: 'fondo-f4-participaciones',
    component: () => import('../views/fondos/f4/participaciones.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/f4/conjuntos/:conjuntoId',
    name: 'fondo-f4-conjunto',
    component: () => import('../views/fondos/f4/conjunto.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/fondos/f3/from-saldo-k10',
    name: 'fondo-f3-from-saldo-k10',
    component: () => import('../views/fondos/f3/adquirir-from-saldo-k10.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // PROGRAMAS R
  {
    path: '/miembros-r',
    name: 'miembros-r',
    component: () => import('../views/programas-r/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/miembros-r/detalles-:slug',
    name: 'detalles_r',
    component: () => import('../views/programas-r/detalles.vue'),
    meta: {
      requiresAuth: true
    }
  },

  //FUSION

  {
    path: '/fusion',
    name: 'fusion',
    component: () => import('../views/fusion/index.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },
  {
    path: '/fusion/tipos-cuentas',
    name: 'fusion_ceutnas',
    component: () => import('../views/fusion/tipos-cuentas.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },
  {
    path: '/fusion/actividades-exito',
    name: 'fusion_actividades_exito',
    component: () => import('../views/fusion/actividades-exito.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },
  {
    path: '/fusion/fusionar/:liderId(\\d+)?',
    name: 'fusion_fusionar',
    component: () => import('../views/fusion/fusionar.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },
  {
    path: '/fusion/cuenta-lider',
    name: 'fusion_cuenta_lider',
    component: () => import('../views/fusion/cuenta-lider.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'fusion'
    }
  },


  // TARJETA ALIANZA

  {
    path: '/tarjeta-alianza',
    name: 'tarjeta_alianza',
    component: () => import('../views/tarjeta-alianza/index.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // NEGOCIOS PATROCINADORES

  {
    path: '/negocios-patrocinadores/:sucursal_id/compra',
    name: 'negocio_patrocinador_compra',
    component: () => import('../views/negocios-patrocinadores/compra.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'negocio-patrocinador'
    }
  },

  //Vista de gestores
  {
    path: '/gestores',
    name: 'gestores',
    component: () => import('../views/gestor/index.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // gestores de Negocios
  {
    path: '/gestores-negocios',
    name: 'gestores_negocio',
    component: () => import('../views/gestores-negocios/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gestores-negocios/:negocio_id/cobranza',
    name: 'gestores_negocio_cobranza',
    component: () => import('../views/gestores-negocios/cobranza.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gestores-negocios/:negocio_id/ventas-patrocinios',
    name: 'gestores_negocio_patrocinios',
    component: () => import('../views/gestores-negocios/ventas-patrocinios.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gestores-negocios/:negocio_id/historial',
    name: 'gestores_negocio_historial',
    component: () => import('../views/gestores-negocios/historial.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gestores-negocios/:negocioId/campania-gratuita',
    name: 'gestores-negocios-campania-gratuita',
    component: () => import('../views/gestores-negocios/campania-gratuita.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // S O L I D A R I D A D
  {
    path: '/solidaridad',
    name: 'solidaridad',
    component: () => import('../views/solidaridad/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/solidaridad/programas-iniciados',
    name: 'solidaridad_programas_iniciados',
    component: () => import('../views/solidaridad/programas-iniciados.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/solidaridad/programas-iniciados/:producto_id',
    name: 'solidaridad_programas_iniciados_detalle',
    component: () => import('../views/solidaridad/programa.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/solidaridad/productos-disponibles',
    name: 'solidaridad_productos_disponibles',
    component: () => import('../views/solidaridad/productos-disponibles.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/solidaridad/mis-programas',
    component: () => import('../views/solidaridad/mis-programas.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/solidaridad/mis-programas/:programa_id',
    component: () => import('../views/solidaridad/beneficios_programa.vue'),
    meta: { requiresAuth: true },
  },

  // E N D   S O L I D A R I D A D

  {
    path: '/user-beneficios',
    name: 'user_beneficios',
    component: () => import('../views/users/Beneficios.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/promociones',
    name: 'promociones',
    component: () => import('../views/promociones.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/codigos-promocionales',
    name: 'codigos_promocionales',
    component: () => import('../views/promotores_ventas/codigos_promocionales.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // R E C A R G A S
  {
    path: '/conecta',
    component: () => import('@/views/conecta/Conecta.vue'),
    children: [
      {
        path: '',
        name: 'conecta',
        component: () => import('../views/conecta/index.vue')
      },
      {
        path: 'transactions',
        name: 'conecta-transactions',
        component: () => import('../views/conecta/transactions.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: ':categoria_slug/:carrier_slug',
        name: 'carrier-products',
        component: () => import('../views/conecta/carrier-products.vue'),
        beforeEnter: (to, from, next) => {
          if (getters.isLoggedIn) {
            next()
          } else {
            next({
              name: 'carrier-difusion',
              params: {categoriaSlug: to.params.categoria_slug, carrierSlug: to.params.carrier_slug}
            })
          }
        }
      },
    ],
    meta: {
      spotBanner: true
    }
  },
  {
    path: '/conecta/:categoriaSlug/:carrierSlug/difusion',
    name: 'carrier-difusion',
    component: () => import('@/views/conecta/carrier-difusion.vue'),
    meta: {
      spotBanner: true,
    }
  },

  // C O L A B O R A D O R E S
  {
    path: '/colaboradores-influencers',
    name: 'colaboradores_influencers',
    component: () => import('../views/colaboradores_influencers/index.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // I N I C I A D O R E S
  {
    path: '/iniciadores',
    name: 'inciadores',
    component: () => import('../views/iniciadores/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // G E M A S  P U B L I C I T A R I A S
  {
    path: '/gemas-publicitarias/comprar',
    name: 'gemas_publicitarias_compra',
    component: () => import('../views/iniciadores/gemas-publicitarias/Comprar.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gemas-publicitarias/orden-detalle/:hex_code',
    name: 'gemas_publicitarias_orden_compra',
    component: () => import('../views/iniciadores/gemas-publicitarias/detalle-orden.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gemas-publicitarias',
    name: 'gemas_publicitarias',
    component: () => import('../views/iniciadores/gemas-publicitarias/gemasUser.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gemas-publicitarias/:coleccion',
    name: 'coleccion_gemas_publicitarias',
    component: () => import('../views/iniciadores/gemas-publicitarias/Coleccion.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/gemas-publicitarias/:coleccion/:gema_id',
    name: 'gema_coleccion_gemas_publicitarias',
    component: () => import('../views/iniciadores/gemas-publicitarias/Gema.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // B O N O S  E S P E C I A L E S
  {
    path: '/bonos-especiales',
    name: 'bonos_especiales',
    component: () => import('../views/bonos-especiales/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  //Slug de categoría a mostrar por defecto
  {
    path: '/bonos-especiales/categoria/:slug',
    name: 'bonos_especiales_slug',
    component: () => import('../views/bonos-especiales/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bonos-especiales/productos-adquiridos',
    name: 'bonos_especiales_/productos_adquiridos',
    component: () => import('../views/bonos-especiales/productos-bono.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lugares-de-produccion',
    name: 'lugares_de_produccion',
    component: () => import('../views/lugares_produccion/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lugares-de-produccion/:id_lugar',
    name: 'lugares_de_produccion_detalle',
    component: () => import('../views/lugares_produccion/lugar'),
    meta: {
      requiresAuth: true
    }
  },

  // C O L A B O R A D O R E S
  /*{
    path: '/colaboradores',
    name: 'colaboradores',
    component: () => import('../views/colaboradores/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },*/

  // iMPULSO lIBERTAD
  {
    path: '/impulso-libertad',
    name: 'impulso_libertad',
    component: () => import('../views/impulso-libertad/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // Carrera de Campeones
  /*{
    path: '/carrera-campeones/:km?',
    name: 'carrera_campeones',
    component: () => import('../views/carrera_campeones/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },*/

  // Puntos
  {
    path: '/puntos',
    name: 'puntos',
    component: () => import('../views/puntos/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/yidi-puntos/:tipo?',
    name: 'yidi-puntos',
    component: () => import('../views/puntos/YidiPuntos.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/puntos-categoria',
    name: 'puntos-categoria',
    component: () => import('../views/puntos/PuntosCategoria.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/puntos-categoria/:slug',
    name: 'puntos-categoria-detalle',
    component: () => import('../views/puntos/categorias/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/saldo',
    name: 'saldo',
    component: () => import('../views/puntos/Saldo.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/puntos-ventas',
    name: 'puntos-ventas',
    component: () => import('../views/puntos/PuntosVentas.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/puntos/saldo/solicitud',
    name: 'solicitud-saldo',
    component: () => import('../views/puntos/solicitud-saldo'),
    meta: {
      requiresAuth: true
    }
  },

  //Red
  {
    path: '/mi-red',
    name: 'red',
    component: () => import('../views/red/MiRed.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // COMERCIALIZADORAS
  {
    path: '/comercializadora',
    name: 'comercializadora',
    component: () => import('../views/comercializadoras/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },

  /*{
    path: '/challenger',
    name: 'challenger',
    component: () => import('../views/challenger/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/challenger/info',
    name: 'challengerInfo',
    component: () => import('../views/challenger/info.vue'),
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/cuponera-tipo',
    name: 'cuponera_tipo',
    component: () => import('../views/cuponera/Tipo.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('../views/Perfil.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/registrar/campania/:codigo',
    name: 'registrarCampania',
    component: () => import('../views/Registrar.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.isLoggedIn) {
        next()
      }
      else {
        next('/')
      }
    },
    meta: {
      navBarGradient: 'white',
      hideNavBar: true
    }
  },
  {
    path: '/registrar/:id(\\d+)?',
    name: 'registrar',
    component: () => import('../views/Registrar.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.isLoggedIn) {
        next()
      }
      else {
        next('/')
      }
    },
    meta: {
      navBarGradient: 'white',
      hideNavBar: true
    }
  },

  {
    path: '/paquetes',
    name: 'paquetes_index',
    component: () => import('../views/paquetes/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/paquetes/compra',
    name: 'paquetes-compra',
    component: () => import('../views/paquetes/compra.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/paquetes/venta',
    name: 'paquetes-venta',
    component: () => import('../views/paquetes/venta.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/paquetes/compra/pendiente/:pendienteId(\\d+)',
    name: 'paquetes-pendiente',
    component: () => import('../views/paquetes/compra.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/pagos',
    name: 'pagos',
    component: () => import('../views/Pagos'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/pagos/:pago_id',
    name: 'pago_detalle',
    component: () => import('../views/pagos/detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },

  /*{
    path: '/paquetes/canjear',
    name: 'paquetes_canjear',
    component: () => import('../views/paquetes/Canjear.vue'),
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/compras',
    name: 'compras',
    component: () => import('../views/compras/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/compras-negocios-patrociandores',
    name: 'compras_negocios_patrocinadores',
    component: () => import('../views/compras/negocios_patrocinadores.vue'),
    meta: {
      requiresAuth: true
    }
  },
  /*{
    path: '/mispreguntas',
    name: 'mispreguntas',
    component: () => import('../views/Mispreguntas.vue'),
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/carrito',
    name: 'carrito_compras',
    component: () => import('../views/compras/Carrito.vue'),
    meta: {
      requiresAuth: true,
      showNavigation: true,
    }
  },
  {
    path: '/compras-especiales',
    name: 'compras_especiales',
    component: () => import('../views/compras/Especiales.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/compras-especiales/:dpto_id/detalle/:tipo?',
    name: 'compras_especiales_detalle',
    component: () => import('../views/compras/especiales/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/compras-especiales/:dpto_id/asignaciones/:asignacion_id',
    name: 'compras_especiales_detalle_asignacion',
    component: () => import('../views/compras/especiales/Asignacion.vue'),
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('../views/Notifications.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/compras/:compra_id/:negocio_id',
    name: 'compra_detalle',
    component: () => import('../views/compras/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/compras/:negocio_id/:compra_id/pay-order/:order_id',
    name: 'compra-order-pay',
    component: () => import('../views/compras/OrdenPago.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/desegurocompras',
    components: {
      default: () => import('../views/desegurocompras/Desegurocompras.vue'),
      navBarBusqueda: () => import("@/components/NavBarBusqueda.vue")
    },
    meta: {
      hideNavBar: true
    },
    children: [
      {
        path: '',
        name: 'home_ds',
        component: () => import('@/views/desegurocompras/Index.vue'),
        meta: {
          spotBanner: true,
          showNavigation: true,
        }
      },
      {
        path: '/desegurocompras/categorias',
        name: 'categorias_ds',
        component: () => import('../views/desegurocompras/Categorias.vue'),
        meta: {
          showNavigation: true,
        }
      },
      {
        path: '/desegurocompras/carrito',
        name: 'carrito-ds',
        component: () => import('../views/desegurocompras/Carrito.vue'),
      },
      {
        path: '/desegurocompras/resultados',
        name: 'resultados-ds',
        component: () => import('../views/desegurocompras/Resultados.vue'),
        meta: {
          showNavigation: true,
        }
      },
      {
        path: '/desegurocompras/preventas',
        component: () => import('../views/desegurocompras/Preventas.vue'),
      },
      {
        path: '/desegurocompras/preventas/:preventa_id',
        component: () => import('../views/desegurocompras/PreventaProductos.vue'),
      },
      {
        path: '/desegurocompras/:subdominio',
        component: () => import('../views/subdominio/Subdominio.vue'),
        children: [
          {
            path: '/desegurocompras/:subdominio/tienda-virtual',
            component: () => import('../views/subdominio/TiendaVirtual.vue'),
          },
          {
            path: ':articulo',
            name: 'desegurocompras-articulo',
            component: () => import('@/views/subdominio/Articulo.vue'),
            meta: {
              spotBanner: true
            }
          },
          {
            path: 'proveedores/:slug/sucursales/:sucursalId',
            name: 'desegurocompras-sucursal',
            component: () => import('../views/subdominio/proveedores/sucursales/detalle'),
          },
        ]
      },
    ]
  },

  /*{
    path: '/catalogo/compras',
    component: () => import('../views/catalogo/compras/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/catalogo/ventas',
    component: () => import('../views/catalogo/ventas/Index'),
    meta: {
      requiresAuth: true
    }
  },*/


  // DEPARTAMENTOS
  {
    path: '/departamentos/:dpto_id',
    name: 'departamentos',
    component: () => import('../views/departamento/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/direcciones-envio',
    name: 'departamento_direcciones',
    component: () => import('../views/departamento/DireccionesEnvio.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/paquetes',
    name: 'departamento_paquetes',
    component: () => import('../views/departamento/Paquetes.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/agentes-entrega',
    name: 'departamento_agentes',
    component: () => import('../views/departamento/AgentesEntrega.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/permisos',
    name: 'departamentos_permisos',
    component: () => import('../views/departamento/Accesos.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores',
    name: 'departamentos_proveedores',
    component: () => import('../views/departamento/Proveedores.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores/:slug',
    name: 'departamento_inventarios',
    component: () => import('../views/departamento/proveedor/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },

  /*{
    path: '/departamentos/:dpto_id/proveedores/:slug/categorias-especiales',
    name: 'proveedor_categorias_especiales',
    component: () => import('../views/departamento/proveedor/categorias-especiales.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores/:slug/categorias-especiales/:categoria_id',
    name: 'proveedor_categorias_especiales_detalle',
    component: () => import('../views/departamento/proveedor/categoria-especial-detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/departamentos/:dpto_id/proveedores/:slug?/publicacion/new',
    name: 'new_publicacion',
    component: () => import('../views/departamento/proveedor/publicacion/New.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores/:slug?/publicacion/:publicacion_id/edit',
    name: 'edit_publicacion',
    component: () => import('../views/departamento/proveedor/publicacion/Edit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores/:slug?/publicacion/:publicacion_id/detalle',
    name: 'detalle_publicacion',
    component: () => import('../views/departamento/proveedor/publicacion/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/proveedores/:slug?/publicacion/:publicacion_id/galeria',
    name: 'galeria_publicacion',
    component: () => import('../views/departamento/proveedor/publicacion/Galeria.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // PREVENTAS USUARIOS
  {
    path: '/preventas',
    name: 'preventas',
    component: () => import('../views/preventas/compras.vue'),
    meta: {
      requiresAuth: true
    }
  },
  // entregas
  {
    path: '/preventas/entregas',
    name: 'preventas_entregas',
    component: () => import('../views/preventas/entregas.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // PREVENTAS

  {
    path: '/departamentos/:dpto_id/preventas',
    name: 'departamento_preventas',
    component: () => import('../views/departamento/preventas/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/preventas/responsables-entrega',
    name: 'departamento_preventas_responsables_entrega',
    component: () => import('../views/departamento/preventas/responsables-entrega.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/preventas/new',
    name: 'departamento_preventas_new',
    component: () => import('../views/departamento/preventas/new.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/preventas/:preventa_id/edit',
    name: 'departamento_preventas_detalle_edit',
    component: () => import('../views/departamento/preventas/edit.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/preventas/:preventa_id/lanzamiento/:lanzamiento_id',
    name: 'departamento_preventas_detalle',
    component: () => import('../views/departamento/preventas/lanzamiento-detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/preventas/:preventa_id/lanzamiento',
    name: 'departamento_preventas_lanzamiento',
    component: () => import('../views/departamento/preventas/lanzamiento.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // VENTAS
  {
    path: '/departamentos/:dpto_id/ventas',
    name: 'ventas',
    component: () => import('../views/ventas/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },  // VENTAS
  {
    path: '/departamentos/:dpto_id/links-cotizacion',
    name: 'ventas_cotizacion_proveedor',
    component: () => import('../views/ventas/cotizacionesProveedor/index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/links-cotizacion/:uuid',
    name: 'ventas_cotizacion_proveedor_detalle',
    component: () => import('../views/ventas/cotizacionesProveedor/detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/ventas/:venta_id',
    name: 'venta_detalle',
    component: () => import('../views/ventas/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/ventas/:venta_id/pagos/:pago_id',
    name: 'venta_detalle_pago',
    component: () => import('../views/ventas/OrdenPago.vue'),
    meta: {
      requiresAuth: true
    }
  },
  //COTIZACIONES DE ENVIO
  {
    path: '/departamentos/:dpto_id/ventas/:venta_id/cotizacion',
    name: 'venta_detalle_cotizacion',
    component: () => import('../views/ventas/cotizaciones/Detalle.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // VENTAS ESPECIALES
  {
    path: '/departamentos/:dpto_id/ventas-especiales/:tipo?',
    name: 'venta_detalle_especiales',
    component: () => import('../views/ventas/Especiales'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/departamentos/:dpto_id/ventas-especiales/asignacion/:asignacion_id',
    name: 'venta_detalle_especiales_asignacion',
    component: () => import('../views/ventas/especiales/Asignacion.vue'),
    meta: {
      requiresAuth: true
    }
  },

  // ACCESOS

  {
    path: '/accesos',
    component: () => import('../views/Accesos.vue'),
    name: 'accesos',
    meta: {
      requiresAuth: true
    }
  },

  // CREDITOS
  {
    path: '/yatvii-credito',
    name: 'yatvii-credito',
    component: () => import('../views/creditos/YatviiCredito.vue'),
    meta: {
      requiresAuth: true
    }
  },
  /*{
    path: '/credito-negocios',
    component: () => import('../views/creditos/credito-gestor-negocios.vue'),
    meta: {
      requiresAuth: true
    }
  },*/
  {
    path: '/credito-patrocinio',
    component: () => import('../views/creditos/credito-patrocinio.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // CUENTA
  {
    path: '/profile/configuracion',
    component: () => import('../views/configuracion/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile/delete-account',
    component: () => import('../views/configuracion/Eliminacion.vue'),
    meta: {
      requiresAuth: true
    }
  },


  // ENVIOS
  /*{
    path: '/reseller-guias',
    name: 'reseller_guias',
    component: () => import('../views/reseller_guias/Index.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reseller-guias/seguimiento/:no_guia',
    name: 'reseller_guias_seguimietno',
    component: () => import('../views/reseller_guias/Seguimiento.vue'),
    meta: {
      requiresAuth: true
    }
  },*/

  // AGENTES DE ENTREGA
  /*{
    path: '/agentes-login',
    name: 'login_agentes',
    component: LoginAgentes,
    beforeEnter: (to, from, next) => {
      if (!store.getters.isLoggedAgente) {
        next()
      }
      else {
        next('/agentes')
      }
    }
  },

  {
    path: '/agentes',
    component: () => import('../views/agentes/Menu.vue'),
    children: [
      {
        path: '',
        component: () => import('../views/agentes/Index.vue')
      },
      {
        path: '/agentes/entregas/pendientes',
        component: () => import('../views/agentes/Pendientes.vue')
      },
      {
        path: '/agentes/entregas/historial',
        component: () => import('../views/agentes/Historial.vue')
      },
      {
        path: '/agentes/entregas/:entrega_id/detalle',
        component: () => import('../views/agentes/EntregaDetalle.vue')
      }
    ],
  },*/

  // CÓDIGOS
  {
    path: '/codigos',
    component: () => import('../views/codigos/index'),
    children: [
      {
        path: 'cupones',
        name: 'codigos-cupones',
        component: () => import('../views/codigos/cupones.vue'),
      },
      {
        path: 'registro',
        name: 'codigos-registro',
        component: () => import('../views/codigos/registro.vue'),
      },
      {
        path: 'productos',
        name: 'codigos-productos',
        component: () => import('../views/codigos/productos.vue'),
      },
      {
        path: 'negocios',
        name: 'codigos-negocios',
        component: () => import('../views/codigos/negocios.vue'),
      },
      {
        path: 'campanias',
        name: 'codigos-campanias',
        component: () => import('../views/codigos/campanias.vue'),
      },
      {
        path: 'carriers',
        name: 'codigos-carriers',
        component: () => import('../views/codigos/carriers.vue'),
      },
      {
        path: 'k10-publicaciones',
        name: 'codigos-k10-publicaciones',
        component: () => import('../views/codigos/k10-publicaciones.vue'),
      },
      {
        path: 'k10-vistas-difusion',
        name: 'codigos-k10-vistas-difusion',
        component: () => import('../views/codigos/k10-vistas-difusion.vue'),
      },
    ],
    meta: {
      requiresAuth: true
    }
  },

  // VISTA DE CARGA DE DEEP LINKS QUE COMPARTEN PRODUCTOS, NEGOCIOS O CAMPAÑAS
  {
    path: '/share/:codigo',
    name: 'share',
    component: () => import('../views/share/index'),
    meta: {
      navBarGradient: 'white'
    }
  },

  //CAMPAÑAS
  {
    path: '/campanias',
    name: 'campanias',
    component: () => import('../views/campanias/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campanias/detalle/:campaniaId',
    name: 'campania_detalle',
    component: () => import('../views/campanias/detalle'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campanias/:campaniaId/orden',
    name: 'campania_orden',
    component: () => import('../views/campanias/orden'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campanias/abrir',
    name: 'campania_abrir',
    component: () => import('../views/campanias/abrir'),
    meta: {
      requiresAuth: true
    }
  },

  //CUPONES DE DESCUENTO
  {
    path: '/cupones-descuento',
    name: 'cupones-descuento',
    component: () => import('../views/cupones-descuento/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/nuevo-cupon/:negocioId(\\d+)',
    name: 'nuevo-cupon',
    component: () => import('../views/cupones-descuento/nuevo-cupon'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/negocios-favoritos',
    name: 'negocios-favoritos',
    component: () => import('../views/cupones-descuento/negocios-favoritos'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/negocio-datos/:negocioId(\\d+)',
    name: 'cupones-negocio-datos',
    component: () => import('../views/cupones-descuento/negocio-vista-cliente'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/negocio-datos/:negocioId(\\d+)/puntos-futuros',
    name: 'cupones-negocio-puntos-futuros',
    component: () => import('../views/cupones-descuento/negocio-puntos-futuros'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/historial/:negocioId(\\d+)',
    name: 'historial-cupones',
    component: () => import('../views/cupones-descuento/historial-cupones'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/historial-general',
    name: 'historial-cupones-general',
    component: () => import('../views/cupones-descuento/historial-cupones-general'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cupones-descuento/puntos-futuros',
    name: 'puntos-futuros',
    component: () => import('../views/cupones-descuento/puntos-futuros'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones',
    name: 'campania-cupones',
    component: () => import('../views/cupones-descuento/negocios/index'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones/negocio-responsable/:negocioId(\\d+)',
    name: 'negocio-cupones-responsable',
    component: () => import('../views/cupones-descuento/negocios/negocio-vista-responsable'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones/negocio-responsable/:negocioId(\\d+)/programa-recuperacion',
    name: 'programa-recuperacion',
    component: () => import('../views/cupones-descuento/negocios/programa-recuperacion'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones/negocio-responsable/:negocioId(\\d+)/programa-recuperacion/historial/:concepto',
    name: 'historial-programa-recuperacion',
    component: () => import('../views/cupones-descuento/negocios/historial-programa-recuperacion'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones/negocio-responsable/:negocioId(\\d+)/historial',
    name: 'negocio-historial-cupones',
    component: () => import('../views/cupones-descuento/historial-cupones'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/campania-cupones/programas-recuperacion',
    name: 'programas-recuperacion',
    component: () => import('../views/cupones-descuento/negocios/programas-recuperacion-negocios'),
    meta: {
      requiresAuth: true
    }
  },

  // CIUDADES CON VIDA DIGNA
  {
    path: '/ciudades-vida-digna',
    name: 'ciudades-vida-digna',
    component: () => import('../views/ciudades-vida-digna/index'),
    meta: {
      requiresAuth: true
    }
  },

  // SPOTS PUBLICITARIOS
  {
    path: '/spots/form/:spotId(\\d+)?',
    component: () => import('../views/spots/formulario/index.vue'),
    children: [
      {
        path: 'general',
        component: () => import('../views/spots/formulario/general.vue'),
        name: 'spots-form-general',
      },
      {
        path: 'banner',
        component: () => import('../views/spots/formulario/banner.vue'),
        name: 'spots-form-banner',
      },
      {
        path: 'intermedio',
        component: () => import('../views/spots/formulario/intermedio.vue'),
        name: 'spots-form-intermedio',
        meta: {
          koinoniaRoute: true
        }
      }
    ],
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10'
    }
  },
  {
    path: '/spots/lista',
    component: () => import('../views/spots/lista/index.vue'),
    children: [
      {
        path: '0',
        component: () => import('../views/spots/lista/status-0.vue'),
        name: 'spots-lista-0',
      },
      {
        path: '1',
        component: () => import('../views/spots/lista/status-1.vue'),
        name: 'spots-lista-1',
      },
      {
        path: '2',
        component: () => import('../views/spots/lista/status-2.vue'),
        name: 'spots-lista-2',
      },
      {
        path: '3',
        component: () => import('../views/spots/lista/status-3.vue'),
        name: 'spots-lista-3',
      }
    ],
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10'
    }
  },

  // KOINONÍA10
  {
    path: '/k10',
    name: 'koinonia10',
    component: () => import('../views/koinonia10/index.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'white'
    }
  },
  {
    path: '/k10/saldo',
    name: 'koinonia10-saldo',
    component: () => import('../views/koinonia10/saldo/index.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
    }
  },
  {
    path: '/k10/saldo/historial/:tipo?',
    name: 'koinonia10-saldo-historial',
    component: () => import('../views/koinonia10/saldo/historial.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
    }
  },
  {
    path: '/k10/beneficios',
    component: () => import('../views/koinonia10/beneficios/index.vue'),
    children: [
      {
        path: 'saldo',
        name: 'koinonia10-beneficios-saldo',
        component: () => import('../views/koinonia10/beneficios/saldo.vue'),
      },
      {
        path: 'personal',
        name: 'koinonia10-beneficios-personal',
        component: () => import('../views/koinonia10/beneficios/semanal.vue'),
      },
      {
        path: 'enlace',
        name: 'koinonia10-beneficios-enlace',
        component: () => import('../views/koinonia10/beneficios/semanal.vue'),
      },
      {
        path: 'vista',
        name: 'koinonia10-beneficios-vista',
        component: () => import('../views/koinonia10/beneficios/semanal.vue'),
      },
    ],
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
    }
  },
  {
    path: '/k10/influencer',
    name: 'koinonia10-influencer',
    component: () => import('../views/koinonia10/influencer/index.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/insignias-titulos',
    name: 'koinonia10-insignias-titulos',
    component: () => import('../views/koinonia10/insignias-titulos.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10'
    }
  },
  {
    path: '/k10/nuevo-perfil',
    name: 'koinonia10-nueva-vista-difusion',
    component: () => import('../views/koinonia10/influencer/vista-difusion-form.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/nueva-publicacion',
    name: 'koinonia10-nueva-publicacion',
    component: () => import('../views/koinonia10/influencer/publicacion-form.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/settings/@:username',
    name: 'koinonia10-editar-vista-difusion',
    component: () => import('../views/koinonia10/influencer/vista-difusion-form.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/@:username/post/:publicacionId(\\d+)/edit',
    name: 'koinonia10-editar-publicacion',
    component: () => import('../views/koinonia10/influencer/publicacion-form.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    },
    props: true
  },
  {
    path: '/k10',
    component: () => import('@/views/koinonia10/red-social-layout.vue'),
    children: [
      {
        path: 'home',
        component: () => import('../views/koinonia10/cronologia/index.vue'),
        children: [
          {
            path: '',
            name: 'koinonia10-cronologia-general',
            component: () => import('../views/koinonia10/cronologia/publicaciones.vue'),
          },
          {
            path: 'profiles',
            name: 'koinonia10-cronologia-general-vistas',
            component: () => import('../views/koinonia10/cronologia/vistas-difusion.vue'),
          },
        ]
      },
      {
        path: '@:username',
        component: () => import('../views/koinonia10/vista-difusion/general.vue'),
        children: [
          {
            path: '',
            name: 'koinonia10-vista-difusion',
            component: () => import('../views/koinonia10/vista-difusion/informacion-general.vue'),
          },
          {
            path: 'publicaciones',
            name: 'koinonia10-vista-difusion-publicaciones',
            component: () => import('../views/koinonia10/vista-difusion/publicaciones.vue'),
          },
        ]
      },
      {
        path: '@:username/post/:publicacionId(\\d+)',
        component: () => import('../views/koinonia10/publicacion/index.vue'),
        children: [
          {
            path: '',
            name: 'koinonia10-publicacion',
            components: {
              default: () => import('@/views/koinonia10/publicacion/all-comments.vue'),
              cronologia: () => import('@/views/koinonia10/publicacion/mas-contenido.vue')
            }
          },
          {
            path: 'comment/:comentarioId(\\d+)',
            name: 'koinonia10-publicacion-comentario',
            component: () => import('@/views/koinonia10/publicacion/comentario.vue'),
          }
        ]
      },
    ],
    meta: {
      navBarGradient: 'koinonia10',
      koinoniaRoute: true,
      spotBanner: true
    }
  },
  {
    path: '/k10/my-content',
    component: () => import('@/views/koinonia10/mi-contenido/index.vue'),
    children: [
      {
        path: '',
        name: 'koinonia10-contenido-publicaciones',
        component: () => import('@/views/koinonia10/mi-contenido/publicaciones.vue')
      },
      {
        path: 'comentarios',
        name: 'koinonia10-contenido-comentarios',
        component: () => import('@/views/koinonia10/mi-contenido/comentarios.vue')
      }
    ],
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/responses/:type/post/:publicacionId(\\d+)',
    name: 'koinonia10-respuestas-publicacion',
    component: () => import('@/views/koinonia10/mi-contenido/respuestas/publicacion.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },
  {
    path: '/k10/responses/:type/comment/:publicacionId(\\d+)/:comentarioId(\\d+)',
    name: 'koinonia10-respuestas-comentario',
    component: () => import('@/views/koinonia10/mi-contenido/respuestas/comentario.vue'),
    meta: {
      requiresAuth: true,
      navBarGradient: 'koinonia10',
      koinoniaRoute: true
    }
  },

  //TRANSFERENCIAS A EFECTIVO
  {
    path: '/transferencias',
    name: 'transferencias',
    component: () => import('../views/transferencias/index.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/transferencias/detalles/:transferenciaId(\\d+)',
    name: 'transferencia-detalles',
    component: () => import('../views/transferencias/detalles.vue'),
    meta: {
      requiresAuth: true,
    }
  },

  // MOSTRAR CUANDO NO HAY CONEXIÓN A INTERNET
  {
    path: '/inactive-connection',
    name: 'inactive-connection',
    component: () => import('../views/inactive-connection'),
    meta: {
      navBarGradient: 'white',
      hideNavBar: true,
    }
  },

  // MANDAR A ESTA RUTA AL CERRAR SESIÓN
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/logout.vue'),
    meta: {
      navBarGradient: 'black',
      hideNavBar: true,
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (getters.isLoggedIn) {
      next()
    } else {
      next('/')
    }
  } else if (to.matched.some(record => record.meta.requiresAuthAgente)) {
    if (getters.isLoggedAgente) {
      next()
    }
    else {
      next('/agentes-login')
    }
  }
  else {
    if (to.matched.length === 0) {
      next('/')
    } else {
      next()
    }
  }
})

router.beforeEach((to, from, next) => {
  //Podría haber una mejor manera de saber si el componente está 'inicializado'
  if ($('.fpm--modal-container').length) {
    Vue.prototype.$FModal.destroyAll()
    store.commit('SET_FULL_MODAL_POSITIONS', [])
  }
  next()
})

router.afterEach((to, from) => {
  let gradient = null
  to.matched.forEach(record => {
    if (record.meta.navBarGradient) {
      gradient = record.meta.navBarGradient
    }
  })

  switch (gradient) {
    case 'koinonia10':
      store.commit('SET_NAVBAR_COLOR', {color1: "#1588D3", color2: "#F9342A"})
      break
    case 'white':
      store.commit('SET_NAVBAR_COLOR', {color1: "#FFFFFF", color2: "#FFFFFF"})
      break
    case 'fusion':
      store.commit('SET_NAVBAR_COLOR', {color1: "#7400F6", color2: "#920039"})
      break
    case 'negocio-patrocinador':
      store.commit('SET_NAVBAR_COLOR', {color1: "#FFE082", color2: "#FFB300"})
      break
    case 'transparent':
      store.commit('SET_NAVBAR_COLOR', {color1: "#FFFFFF00", color2: "#FFFFFF00"})
      break
    case 'black':
      store.commit('SET_NAVBAR_COLOR', {color1: "#000000", color2: "#000000"})
      break
    default:
      store.commit('SET_NAVBAR_COLOR', {color1: "#FFA500", color2: "#FF6347"})
  }
})

router.beforeResolve((to, from, next) => {
  if (to.name !== 'inactive-connection') {
    Network.getStatus().then(status => {
      if (!status.connected) {
        next('/inactive-connection')
      } else {
        next()
      }
    })
  } else {
    next()
  }
})

export default router